module.exports = "section {\r\n    margin-bottom: 0 !important;\r\n}"